import { render, staticRenderFns } from "./overflowAlertor.vue?vue&type=template&id=7d0cc6f9&scoped=true"
import script from "./overflowAlertor.vue?vue&type=script&lang=js"
export * from "./overflowAlertor.vue?vue&type=script&lang=js"
import style0 from "./overflowAlertor.vue?vue&type=style&index=0&id=7d0cc6f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0cc6f9",
  null
  
)

export default component.exports